import { LinearProgress } from '@mui/material';
import React from 'react';
import { Modal } from '../../../components';
import { useSelector } from '../../../stores';

export const CredentialsExportModal: React.FC = () => {
  const { credentialsExportPercentage, credentialsExportModalIsOpen } =
    useSelector((state) => state.credentialsListSliceReducer);

  return (
    <Modal
      open={credentialsExportModalIsOpen}
      onClose={() => {}}
      title='Preparando exportação'
      noCloseButton
    >
      <LinearProgress
        variant='determinate'
        value={credentialsExportPercentage}
        sx={{ height: '20px', borderRadius: '40px' }}
      />
    </Modal>
  );
};
